import BackButton from '../../components/shared/BackButton/BackButton';
import styles from './page-internal-bid-form.module.scss';
import { RouteComponentProps } from 'react-router-dom';
import { useEffect, useState, FC } from 'react';
import { ServiceQuotation } from '../../services/service-quotation';
import Tabs from '../../components/shared/Tabs';
import QuotationForm, { VersionData } from '../page-quotation/QuotationForm/QuotationForm';
import AppLayout from '../../components/layout/app-layout/app-layout';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SupplierIcon } from '../../assets/svg/suppliers.svg';

type Supplier = {
  id: string;
  name: string;
  slug: string;
}

type Params = {
  areaSlug: string;
  project: string;
  supplierSlug: string;
}

type RouteTypes = RouteComponentProps<Params, Record<string, unknown>, { supplierId?: string }>

type Props = {
  history: RouteTypes['history'];
  match: RouteTypes['match'];
}

const PageInternalBidForm: FC<Props> = ({ history, match }) => {
  const [t] = useTranslation('projects', { keyPrefix: 'internalBidForm' });
  const { areaSlug, project, supplierSlug } = match.params;
  const [projectName, setProjectName] = useState('');
  const [areaName, setAreaName] = useState('');
  const [loading, setLoading] = useState(true);
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);
  const [selectedTab, setSelectedTab] = useState<number>(-1);
  const [selectedSupplier, setSelectedSupplier] = useState<Supplier>();
  const [quotationVersions, setQuotationVersions] = useState<VersionData[]>([]);

  useEffect(() => {
    setLoading(true);
    (async () => {
      const { projectName, areaName, uniqueSuppliers }: { projectName: string, areaName: string, uniqueSuppliers: Supplier[] } = await ServiceQuotation.getUniqueQuotationSuppliers(project, areaSlug);
      setSuppliers(uniqueSuppliers);
      setProjectName(projectName);
      setAreaName(areaName);
      setLoading(false);
    })()
  }, []);

  useEffect(() => {
    if (suppliers?.length) {
      setSelectedTab(supplierSlug ? (suppliers.findIndex(supplier => supplier.slug === supplierSlug) || 0) : -1);
    }
  }, [suppliers]);

  useEffect(() => {
    if (selectedTab >= 0)
      setSelectedSupplier(suppliers[selectedTab])
  }, [selectedTab]);

  useEffect(() => {
    if (selectedSupplier) {
      (async () => {
        const quotation = await ServiceQuotation.getProjectQuotation(project, areaSlug, selectedSupplier.id);
        setQuotationVersions(quotation);
      })()
    }
  }, [selectedSupplier]);

  return (
    <AppLayout title={<BackButton onClick={() => {
      const url = match.url.split('/');
      url.splice(5);
      history.push(url.join('/'));
    }} path={[projectName, t('pageTitle', 'Anbud för {{areaName}}', {areaName})]} />}>
      <div className={styles.container}>
        {!loading && (
          selectedSupplier ? (
            <div>
              <Tabs tabs={suppliers.map(supplier => supplier.name)} selected={selectedTab} onChange={tabIndex => {
                  setSelectedTab(tabIndex);
                  const updatedUrl = match.url.substring(0, match.url.lastIndexOf('/') + 1) + suppliers[tabIndex].slug;
                  history.push(updatedUrl)
                }} />
              <QuotationForm key={quotationVersions?.[0]?.supplier?._id} quotationVersions={quotationVersions} />
            </div>
          ) : (
            <div>
              <Tabs tabs={suppliers.map(supplier => supplier.name)} selected={undefined} onChange={tabIndex => {
                  setSelectedTab(tabIndex);
                  const updatedUrl = match.url + '/' + suppliers[tabIndex].slug;
                  history.push(updatedUrl)
                }} />
              <div className="flex justify-center">
                <SupplierIcon width="56" height="56" color="#9CA3AF" />
              </div>
              <p className={styles.noVersions}>{t('noSupplierSelected', 'Välj en leverantör för att lägga till ett bud.')}</p>
            </div>
          )
        )}
      </div>
      </AppLayout>
  );
}

export default PageInternalBidForm;
